var _g;
var _excluded = ["title", "titleId"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1264.000000, -383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-color",
    transform: "translate(1120.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-3",
    transform: "translate(0.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Folder-Open/Multicolour/Colourful",
    transform: "translate(144.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.87833564,8.65125662 L7.10542736e-15,13.5854272 L7.10542736e-15,2 L7.10542736e-15,2 C7.10542736e-15,0.895429883 0.895429883,-5.68434189e-14 2,-5.68434189e-14 L8.6666736,-5.68434189e-14 L11.3333424,2.6666688 L18.0000144,2.6666688 L18.0000143,2.6666688 C19.104586,2.66666875 20.0000159,3.56209868 20.0000159,4.6666704 L20.0000159,6.666672 L6.33333831,6.666672 L6.33333812,6.666672 C4.91139948,6.66935454 3.59705676,7.42432677 2.87833535,8.65125692 L2.87833564,8.65125662 Z",
    id: "path_secondary",
    fill: "#98A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3333384,8.00000603 L23.0000184,8.00000603 L23.0000184,8.00000603 C23.5523022,8.00000603 23.9999192,8.44782312 23.9999192,9.0001069 C23.9999192,9.17708037 23.9529192,9.35087926 23.8637687,9.5037573 L20.8445996,14.6770948 L20.8445997,14.6770946 C20.3667701,15.4961536 19.4899319,15.9998582 18.5416812,16.000006 L1.87500118,16.000006 L1.8750012,16.000006 C1.32271743,16.000006 0.875100401,15.5521953 0.875100401,14.9999116 C0.875100401,14.8229381 0.922100438,14.6491392 1.01125093,14.4962611 L4.03000334,9.32292368 L4.03000329,9.32292376 C4.50790784,8.5037356 5.38493771,8.00000603 6.33333847,8.00000603 L6.3333384,8.00000603 Z",
    id: "path_primary",
    fill: "#4C69BA"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon-folder.ff21104e.svg";
export { ForwardRef as ReactComponent };